import React from 'react';
import './App.css';
import Draggable from 'react-draggable';

function Note(props) {

    const textRef = React.useRef(null);

    // Note no 'setter'
    const [noteStyle] = React.useState({
        // Note that a "note" is 150 pixels by 150 pixels
        //     as defined in "App.css"
        right: randomBetween(0, window.innerWidth  - 150, "px"),
        top:   randomBetween(0, window.innerHeight - 150, "px")
    });

    const [editing, setEditing] = React.useState(false);
    React.useEffect(() => {
        if (editing) {
            textRef.current.focus();
            textRef.current.select();
        }
    }, [editing]); // Effect is only triggered if 'editing' changes

    function randomBetween(x, y, units) {
        return (x + Math.ceil(Math.random() * (y - x))) + units;
    }

    function edit() {
        setEditing(true);
    }

    function save() {
        props.onChange(textRef.current.value, props.id);
        setEditing(false);
    }

    function remove() {
        props.onRemove(props.id);
    }

    function renderForm() {
        return (
            <div className="note" style={noteStyle}>
                <textarea ref={textRef} defaultValue={props.children}>
                </textarea>
                <button onClick={save}>SAVE</button>
            </div>
        );
    }

    function renderDisplay() {
        return (
            <div className="note" style={noteStyle}>
                <p>{props.children}</p>
                <span>
                    <button onClick={edit}>EDIT</button>
                    <button onClick={remove}>X</button>
                </span>
            </div>
        );
    }

    return (
        <Draggable>
            {(editing) ? renderForm() : renderDisplay()}
        </Draggable>
    );
}

export default Note;
